import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

/**
 * Elimina documentos de liquidación usando el endpoint correspondiente.
 * @param oidLiquidacion - Identificador de la liquidación a eliminar
 * @returns Promesa con la respuesta del backend
 */
export const deleteSettlementDocuments = async (
  oidLiquidacion: number | string
): Promise<unknown> => {
  try {
    const res = await apiClient.post(Endpoints.EliminarLiquidacionDocumentos, {
      oidLiquidacion,
    });
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
